bindObservableMethods